import React, { useState, useEffect } from 'react';
import { Input } from "./styles";
import formatter from "../../../../../../utils/formatter";

const InputCustom = (props) => {
    const { value, onChange, disabled, regexp = /^\d+$/, field, title} = props;
    const [val, setVal] = useState('');
    const [inEdit, setEdit] = useState(false);
    useEffect(() => {
        setVal(value);
    }, [value]);

    const onChangeLocal = (e) => {
        if (e.target.value === '' || regexp.test(e.target.value)) {
            setVal(e.target.value);
            onChange(e.target.value);
        }
    }

    const onFocus = () => {
        setEdit(true);
    }

    const onBlur = () => {
        setEdit(false);
    }
    
    if (inEdit) {
        return (
            <Input 
                type='text'
                title={title}
                value={val ? val : ''} 
                onChange={(e) => onChangeLocal(e)} 
                disabled={disabled} 
                onBlur={onBlur}
                aria-label={props.field}
            />
        );
    } else {
        return (
            <Input 
                type='text' 
                title={title}
                value={val ? formatter({value: val, fieldSuffix: field}) : ''} 
                disabled={disabled}
                onFocus={onFocus}
                aria-label={props.field}
            />
        );
    }
    
}

export default InputCustom;